import { z } from 'zod'

import { phoneSchema } from '@/shared/lib/validation/phone'

export type SignInData = {
	SHOW_SMS_FIELD: boolean
	IS_NEW_USER: boolean
	SIGNED_DATA: string
	TYPE_AUTH: 'push' | string
}

export type SignInResponseData = {
	ACCESS_TOKEN: string
	REFRESH_TOKEN: string
	IS_EMAIL_INVALID: boolean
}

export const AuthByPhoneSchema = z.object({
	phone: phoneSchema
})

export type AuthByPhoneForm = z.infer<typeof AuthByPhoneSchema>
